import { apis } from "../constants";
import { request } from "../utils";

export const searchJobs = () => {
    return request<JobRecord[]>(apis.searchJobs)
}

export const rescheduleJobs = (data: Partial<RescheduleJobPayload>) => {
    return request(apis.rescheduleJobs, {
        method: 'post', data
    })
}